let prefecturalList = {
  // 南阳
  "邓州": {
    prod: {
      cityName: "邓州市",
      deptId: 24258,
      lesseeId: 1652,
      // onlineUrl: "http://117.159.15.238:16070",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.192.106.56:10009/login?redirect=/index&ssoUrl=http://117.159.15.238:16064',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://117.159.15.238:16110/login?redirect=/index&ssoUrl=http://117.159.15.238:16064',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16068',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.15.238:16020/login?redirect=/index&ssoUrl=http://117.159.15.238:16064',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.15.238:16034/login?redirect=/index&ssoUrl=http://117.159.15.238:16064',
        },

        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16066',
        },
      ],
      homeBackImg: require("@/assets/img/dengzhou.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },

  },
  // 南阳
  "淅川": {
    prod: {
      cityName: "淅川县",
      deptId: 20709,
      lesseeId: 1652,
      // onlineUrl: "http://117.159.15.238:16069",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.192.106.56:10009/login?redirect=/index&ssoUrl=http://117.159.15.238:16064',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://117.159.15.238:16110/login?redirect=/index&ssoUrl=http://117.159.15.238:16064',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16067',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.15.238:16020/login?redirect=/index&ssoUrl=http://117.159.15.238:16064',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.15.238:16034/login?redirect=/index&ssoUrl=http://117.159.15.238:16064',
        },

        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16065',
        },
      ],
      homeBackImg: require("@/assets/img/xichuan.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },

  },
  // 新乡1
  "新乡": {
    prod: {
      cityName: "新乡市",
      deptId: 1601,
      lesseeId: 1601,
      // onlineUrl: "http://117.159.15.238:16042",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.92.70.79:10012?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://1.92.70.79:10013?ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://1.92.70.79:10015?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://1.92.70.79:10017?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://1.92.70.79:10014?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
      ],
      homeBackImg: require("@/assets/img/xinxiang.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 新乡1
  "新乡高新区": {
    prod: {
      cityName: "新乡市高新区",
      deptId: 3760,
      lesseeId: 3760,
      // onlineUrl: "http://117.159.15.238:16042",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.92.70.79:10012?redirect=/index&ssoUrl=http://117.159.15.238:16136',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://1.92.70.79:10013?ssoUrl=http://117.159.15.238:16136',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://1.92.70.79:10015?redirect=/index&ssoUrl=http://117.159.15.238:16136',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://1.92.70.79:10017?redirect=/index&ssoUrl=http://117.159.15.238:16136',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://1.92.70.79:10014?redirect=/index&ssoUrl=http://117.159.15.238:16136',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16135',
        },
      ],
      homeBackImg: require("@/assets/img/xinxiang.png"),
      showAppImage: true,
      appImage: require("@/assets/img/xinxianggaoxinquAppImage.png"),
      tabList: [
        { name: '首页', router: '/' },
        // { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 新乡1
  "封丘": {
    prod: {
      cityName: "封丘县",
      deptId: 1610,
      lesseeId: 1610,
      // onlineUrl: "http://117.159.15.238:16042",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.92.70.79:10012?redirect=/index&ssoUrl=http://1.92.70.79:10053',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://1.92.70.79:10013?ssoUrl=http://1.92.70.79:10053',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://1.92.70.79:10015?redirect=/index&ssoUrl=http://1.92.70.79:10053',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://1.92.70.79:10017?redirect=/index&ssoUrl=http://1.92.70.79:10053',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://1.92.70.79:10054',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://1.92.70.79:10014?redirect=/index&ssoUrl=http://1.92.70.79:10053',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://1.92.70.79:10051',
        },
      ],
      homeBackImg: require("@/assets/img/xinxiang.png"),
      showAppImage: true,
      appImage: require("@/assets/img/fengqiuAppImage.png"),
      footList: [
        {
          title: "主管部门",
          company: "封丘县农业农村局",
        },
        {
          title: "监督部门",
          company: "封丘县纪委监委",
        },
        {
          title: "技术单位",
          company: "河南晟宇信息技术有限公司",
        },
      ],
      tabList: [
        { name: '首页', router: '/' },
        // { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 新乡1
  "辉县": {
    prod: {
      cityName: "辉县市",
      deptId: 12623,
      lesseeId: 1601,
      // onlineUrl: "http://117.159.15.238:16035",
      havaLink: true,
      doubletitle: true,
      notShowWatchNum: true,
      showAuctionRecords: true,
      homeShowLogin: true,
      doubletitleText: "农村产权交易信息服务平台",
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.92.70.79:10012?redirect=/index&ssoUrl=http://117.159.15.238:16032',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://1.92.70.79:10015?redirect=/index&ssoUrl=http://117.159.15.238:16032',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://1.92.70.79:10013?redirect=/index&ssoUrl=http://117.159.15.238:16032',
        },
        {
          name: '辉县农票',
          image: require('@/assets/img/cwgk.png'),
          src: 'http://1.92.70.79:10057?redirect=/index&ssoUrl=http://117.159.15.238:16032',
        },
        {
          name: '农票质押',
          image: require('@/assets/img/qchz.png'),
          src: 'http://1.92.70.79:10056',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/gqglxt.png'),
          src: 'http://117.159.15.238:16031',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16037',
        },
        // {
        //   name: '合同管理',
        //   image: require('@/assets/img/htgl.png'),
        //   src: 'http://1.92.70.79:10017?redirect=/index&ssoUrl=http://117.159.15.238:16032',
        // },
      ],
      homeBackImg: require("@/assets/img/huixian.png"),
      showAppImage: true,
      appImage: require("@/assets/img/huixianAppImage.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '数据中心', href: 'http://117.159.15.238:16175/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
    dev: {
      cityName: "辉县市",
      deptId: 51737,
      lesseeId: 1601,
      havaLink: true,
      doubletitle: true,
      notShowWatchNum: true,
      showAuctionRecords: true,
      homeShowLogin: true,
      doubletitleText: "农村产权交易信息服务平台",
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://39.164.142.214:10030/login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://39.164.142.214:10022?ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://39.164.142.214:2244?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://39.164.142.214:9907',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://39.164.142.214:10034?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '辉县农票',
          image: require('@/assets/img/qchz.png'),
          src: 'http://39.164.142.214:9909/?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '农票质押',
          image: require('@/assets/img/gqglxt.png'),
          src: 'http://39.164.142.214:9906/',
        },
      ],
      homeBackImg: require("@/assets/img/huixian.png"),
      showAppImage: true,
      appImage: require("@/assets/img/huixianAppImage.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 新乡1
  "牧野区": {
    prod: {
      cityName: "牧野区",
      homeTitle: "农村集体财产监督管理平台",
      deptId: 24265,
      lesseeId: 1601,
      // onlineUrl: "http://117.159.15.238:16073",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.92.70.79:10012?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://1.92.70.79:10015?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16074',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://1.92.70.79:10013?ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://1.92.70.79:10017?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16075',
        },
      ],
      homeBackImg: require("@/assets/img/xinxiang.png"),
      showAppImage: true,
      appImage: require("@/assets/img/muyequAppImage.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
      footList: [
        {
          title: "主管部门",
          company: "牧野区农业农村局",
        },
        {
          title: "监督部门",
          company: "牧野区纪委监委",
        },
        {
          title: "技术单位",
          company: "河南晟宇信息技术有限公司",
        },
      ],
    },
  },
  // 新乡1
  "获嘉": {
    prod: {
      cityName: "获嘉县",
      homeTitle: "农村集体资产监督管理平台",
      deptId: 19050,
      deptCode: 410724,
      lesseeId: 1601,
      // onlineUrl: "http://117.159.15.238:16050",
      havaLink: true,
      doubletitle: true,
      showAuctionRecords: true,
      notShowAuctionRecordsName: true,
      startWebSocket: true,
      haveCJGG: true,
      chargeStandard: true,
      haveFootLink: true,
      notShowWatchNum: true,
      notShowPublicity: true,
      projectCardShowStatusList: [
        '',
        '',
        '预公告',
        '预公告结束',
        '公示中',
        '公示结束',
        '竞价中',
        '已成交',
        '已成交',
        '已成交',
        "已结束",
        "已结束"
      ],
      initPriceTitle: "起始价格",
      bargainPriceTitle: "成交价格",
      ZCZSName: "产业招商",
      projectTypeList: [
        {
          label: '产权交易',
          type: 2,
          li_bg: [],
        },
        {
          label: '招标采购',
          type: 3,
          li_bg: [],
        },
      ],
      projectAllStatus: "2,4,5,6,7,8,9,10,11",
      projectStatusList: [
        {
          status: '预公告',
          statusImg: require('../assets/img/报名中.png'),
          statusImg1: require('../assets/img/报名中1.png'),
          statusStr: '2',
        },
        {
          status: '公示中',
          statusImg: require('../assets/img/报名中.png'),
          statusImg1: require('../assets/img/报名中1.png'),
          statusStr: '4',
        },
        {
          status: '竞价中',
          statusImg: require('../assets/img/竞价中.png'),
          statusImg1: require('../assets/img/竞价中1.png'),
          statusStr: '6',
        },
        {
          status: '已成交',
          statusImg: require('../assets/img/已成交.png'),
          statusImg1: require('../assets/img/已成交1.png'),
          statusStr: '7,8,9',
        },
      ],
      footLinkList: [
        {
          label: "农业农村部",
          url: "https://www.moa.gov.cn/",
        },
        {
          label: "农业农村厅",
          url: "https://nynct.henan.gov.cn/",
        },
        {
          label: "自然资源部",
          url: "https://www.mnr.gov.cn/",
        },
        {
          label: "公共资源交易中心",
          url: "https://www.ggzy.gov.cn/",
        },
        {
          label: "获嘉县人民政府",
          url: "http://www.huojia.gov.cn/",
        },
      ],
      doubletitleText: "农村产权交易信息服务平台",
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.92.70.79:10012?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://1.92.70.79:10013?ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://1.92.70.79:10015?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16062',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://1.92.70.79:10017?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://1.92.70.79:10014?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16061',
        },
      ],
      homeBackImg: require("@/assets/img/huojia.png"),
      showAppImage: true,
      appImage: require("@/assets/img/huojiaAppImage.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '监督管理', href: 'http://117.159.15.238:16039' },
        { name: '交易项目', router: '/tradingProject' },
        { name: '产业招商', router: '/propertyAttract' },
        { name: '数据中心', href: 'http://117.159.15.238:16174/' },
        // { name: '所在区域', router: '/szqy', type: 1 },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
        // { name: '交易类型', router: '/jylx', type: 2 },
        // { name: '交易大数据', router: '/xinyangBigData', andCity: true },
      ],
    },
    dev: {
      cityName: "获嘉县",
      homeTitle: "农村集体资产监督管理平台",
      deptId: 51503,
      deptCode: 410724,
      lesseeId: 1601,
      havaLink: true,
      doubletitle: true,
      showAuctionRecords: true,
      notShowAuctionRecordsName: true,
      startWebSocket: true,
      haveCJGG: true,
      chargeStandard: true,
      haveFootLink: true,
      notShowWatchNum: true,
      notShowPublicity: true,
      projectCardShowStatusList: [
        '',
        '',
        '预公告',
        '预公告结束',
        '公示中',
        '公示结束',
        '竞价中',
        '已成交',
        '已成交',
        '已成交',
        "已结束",
        "已结束"
      ],
      initPriceTitle: "起始价格",
      bargainPriceTitle: "成交价格",
      ZCZSName: "产业招商",
      projectTypeList: [
        {
          label: '产权交易',
          type: 2,
          li_bg: [],
        },
        {
          label: '招标采购',
          type: 3,
          li_bg: [],
        },
      ],
      projectAllStatus: "2,4,5,6,7,8,9,10,11",
      projectStatusList: [
        {
          status: '预公告',
          statusImg: require('../assets/img/报名中.png'),
          statusImg1: require('../assets/img/报名中1.png'),
          statusStr: '2',
        },
        {
          status: '公示中',
          statusImg: require('../assets/img/报名中.png'),
          statusImg1: require('../assets/img/报名中1.png'),
          statusStr: '4',
        },
        {
          status: '竞价中',
          statusImg: require('../assets/img/竞价中.png'),
          statusImg1: require('../assets/img/竞价中1.png'),
          statusStr: '6',
        },
        {
          status: '已成交',
          statusImg: require('../assets/img/已成交.png'),
          statusImg1: require('../assets/img/已成交1.png'),
          statusStr: '7,8,9',
        },
      ],
      footLinkList: [
        {
          label: "农业农村部",
          url: "https://www.moa.gov.cn/",
        },
        {
          label: "农业农村厅",
          url: "https://nynct.henan.gov.cn/",
        },
        {
          label: "自然资源部",
          url: "https://www.mnr.gov.cn/",
        },
        {
          label: "公共资源交易中心",
          url: "https://www.ggzy.gov.cn/",
        },
        {
          label: "获嘉县人民政府",
          url: "http://www.huojia.gov.cn/",
        },
      ],
      doubletitleText: "农村产权交易信息服务平台",
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://39.164.142.214:10030/login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.53.44:10013',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://39.164.142.214:10034/login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://39.164.142.214:10022/login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://39.164.142.214:2244/login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.53.44:10016/',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://39.164.142.214:10027//login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
      ],
      homeBackImg: require("@/assets/img/huojia.png"),
      showAppImage: true,
      appImage: require("@/assets/img/huojiaAppImage.png"),
      tabList: [
        { name: '首页', router: '/' },
        // { name: '数据中心', href: 'http://117.159.15.238:16174/' },
        // { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '成交公告', router: '/chengjiaogonggao' },
        // { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '产业招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        // { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 新乡1
  "凤泉区": {
    prod: {
      cityName: "凤泉区",
      homeTitle: "农村集体财产监督管理平台",
      deptId: 1604,
      deptCode: 410704,
      lesseeId: 1604,
      // onlineUrl: "http://117.159.15.238:16050",
      havaLink: true,
      doubletitle: true,
      startWebSocket: true,
      chargeStandard: true,
      doubletitleText: "农村产权交易信息服务平台",
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.92.70.79:10012?redirect=/index&ssoUrl=http://117.159.15.238:16164',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://1.92.70.79:10013?ssoUrl=http://117.159.15.238:16164',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://1.92.70.79:10015?redirect=/index&ssoUrl=http://117.159.15.238:16164',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16162/',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://1.92.70.79:10017?redirect=/index&ssoUrl=http://117.159.15.238:16164',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://1.92.70.79:10014?redirect=/index&ssoUrl=http://117.159.15.238:16164',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16100',
        },
      ],
      homeBackImg: require("@/assets/img/huixian.png"),
      showAppImage: true,
      appImage: require("@/assets/img/fengquanquAppImage.png"),
      tabList: [
        { name: '首页', router: '/' },
        // { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 新乡1
  "延津": {
    prod: {
      cityName: "延津县",
      deptId: 16571,
      lesseeId: 1601,
      // onlineUrl: "http://117.159.15.238:16055",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.92.70.79:10012?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://1.92.70.79:10013?ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://1.92.70.79:10015?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://1.92.70.79:10017?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://1.92.70.79:10014?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/cwgk.png'),
          src: 'http://117.159.15.238:16054/',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16057/',
        },
      ],
      homeBackImg: require("@/assets/img/xinxiang.png"),
      showAppImage: true,
      appImage: require("@/assets/img/yanjinAppImage.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
      footList: [
        {
          title: "主管部门",
          company: "延津县农业农村局",
        },
        {
          title: "监督部门",
          company: "延津县纪委监委",
        },
        {
          title: "技术单位",
          company: "河南晟宇信息技术有限公司",
        },
      ]
    },
  },
  // 新乡1
  "卫滨区": {
    prod: {
      cityName: "卫滨区",
      deptId: 25686,
      lesseeId: 1601,
      // onlineUrl: "http://117.159.15.238:16078",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.92.70.79:10012?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://1.92.70.79:10015?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16077',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://1.92.70.79:10013?ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://1.92.70.79:10017?redirect=/index&ssoUrl=http://117.159.15.238:16039',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16079',
        },

      ],
      homeBackImg: require("@/assets/img/xinxiang.png"),
      showAppImage: true,
      appImage: require("@/assets/img/weibinquAppImage.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
      footList: [
        {
          title: "主管部门",
          company: "卫滨区农业农村局",
        },
        {
          title: "监督部门",
          company: "卫滨区纪委监委",
        },
        {
          title: "技术单位",
          company: "河南晟宇信息技术有限公司",
        },
      ],
    },
  },
  // 新乡
  "平原新区": {
    prod: {
      cityName: "新乡市平原城乡一体化示范区",
      homeTitle: "农村集体资产监督管理平台",
      deptId: 3758,
      lesseeId: 3758,
      loginImg: require("@/assets/img/xuchangLoginBk.png"),
      // onlineUrl: "http://117.159.15.238:16091/#/",
      havaLink: true,
      notShowWatchNum: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.92.70.79:10012?redirect=/index&ssoUrl=http://117.159.15.238:16090',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://1.92.70.79:10015?redirect=/index&ssoUrl=http://117.159.15.238:16090',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16089',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://1.92.70.79:10013?redirect=/index&ssoUrl=http://117.159.15.238:16090',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://1.92.70.79:10017?redirect=/index&ssoUrl=http://117.159.15.238:16090',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16088',
        },
      ],
      homeBackImg: require("@/assets/img/pingyuanxinqu.png"),
      showAppImage: true,
      appImage: require("@/assets/img/pingyuanxinquAppImage.png"),
      tabList: [
        { name: '首页', router: '/' },
        // { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 新乡
  "长垣": {
    prod: {
      cityName: "长垣市",
      homeTitle: "农村集体财产监督管理平台",
      toCityChangeTitle: true,
      deptId: 1611,
      lesseeId: 1611,
      // onlineUrl: "http://117.159.15.238:16035",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.92.70.79:10012?redirect=/index&ssoUrl=http://117.159.15.238:16095',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16097',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://1.92.70.79:10015?redirect=/index&ssoUrl=http://117.159.15.238:16095',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16096',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://1.92.70.79:10013?ssoUrl=http://117.159.15.238:16095',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://1.92.70.79:10017?redirect=/index&ssoUrl=http://117.159.15.238:16095',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://1.92.70.79:10014?redirect=/index&ssoUrl=http://117.159.15.238:16095',
        },
      ],
      homeBackImg: require("@/assets/img/xinxiang.png"),
      showAppImage: true,
      appImage: require("@/assets/img/changyuanAppImage.png"),
      tabList: [
        { name: '首页', router: '/' },
        // { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
      footList: [
        {
          title: "主管部门",
          company: "长垣市农业农村局",
        },
        {
          title: "监督部门",
          company: "长垣市纪委监委",
        },
        {
          title: "技术单位",
          company: "河南晟宇信息技术有限公司",
        },
      ],
    },
  },
  // 许昌
  "许昌": {
    prod: {
      cityName: "许昌市",
      homeTitle: "农村集体综合服务平台",
      deptId: 1632,
      deptCode: 4110,
      toCityChangeTitle: true,
      lesseeId: 1632,
      showAuctionRecords: true,
      // onlineUrl: "http://117.159.53.44:10008",
      startWebSocket: true,
      havaLink: true,
      freeBidding: false,
      chargeStandard: true,
      initPriceTitle: "挂牌价格",
      notGoCityList: [
        "开发区",
        "东城区",
        "示范区",
      ],
      projectStatusList: [
        {
          status: '公示中',
          statusImg: require('../assets/img/公示中.png'),
          statusImg1: require('../assets/img/公示中1.png'),
          statusStr: '2',
        },
        {
          status: '报名中',
          statusImg: require('../assets/img/报名中.png'),
          statusImg1: require('../assets/img/报名中1.png'),
          statusStr: '4',
        },
        {
          status: '竞价中',
          statusImg: require('../assets/img/竞价中.png'),
          statusImg1: require('../assets/img/竞价中1.png'),
          statusStr: '6',
        },
        {
          status: '已成交',
          statusImg: require('../assets/img/已成交.png'),
          statusImg1: require('../assets/img/已成交1.png'),
          statusStr: '7,8,9',
        },
      ],
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://117.159.53.44:10007/login?redirect=/index&ssoUrl=http://117.159.53.44:10006',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.53.44:10013',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://117.159.53.44:10010/login?redirect=/index&ssoUrl=http://117.159.53.44:10006',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.53.44:10015?ssoUrl=http://117.159.53.44:10006',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.53.44:10014/login?redirect=/index&ssoUrl=http://117.159.53.44:10006',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.53.44:10016/login',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://117.159.53.44:10009/login?redirect=/index&ssoUrl=http://117.159.53.44:10006',
        },
      ],
      homeBackImg: require("@/assets/img/xuchang.png"),
      showAppImage: true,
      appImage: require("@/assets/img/xuchangAppImage.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
    dev: {
      cityName: "许昌市",
      homeTitle: "农村集体综合服务平台",
      deptId: 1632,
      deptCode: 4110,
      toCityChangeTitle: true,
      lesseeId: 1632,
      showAuctionRecords: true,
      startWebSocket: true,
      havaLink: true,
      freeBidding: false,
      notGoCityList: [
        "开发区",
        "东城区",
        "示范区",
      ],
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://39.164.142.214:10030/login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.53.44:10013',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://39.164.142.214:10034/login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://39.164.142.214:10022/login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://39.164.142.214:2244/login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.53.44:10016/',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://39.164.142.214:10027//login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
      ],
      homeBackImg: require("@/assets/img/xuchang.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 驻马店
  "上蔡": {
    prod: {
      cityName: "上蔡县",
      deptId: 9214,
      lesseeId: 1698,
      homeTitle: "农村产权交易中心",
      // onlineUrl: "http://117.159.15.238:16059",
      backGroundUrl: "http://117.159.15.238:16020?ssoUrl=http://117.159.15.238:16038",
      havaLink: false,
      backstageUrlList: [
        {
          name: '数据分析平台',
          image: require('@/assets/img/sjfxpt.png'),
          src: 'http://117.159.15.238:16036/',
        },
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.192.106.56:10009?redirect=/index&ssoUrl=http://117.159.15.238:16038',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.15.238:16020?ssoUrl=http://117.159.15.238:16038',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://117.159.15.238:16110/login?redirect=/index&ssoUrl=http://117.159.15.238:16038',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.15.238:16021/login?redirect=/index&ssoUrl=http://117.159.15.238:16038',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://117.159.15.238:16043/login?redirect=/index&ssoUrl=http://117.159.15.238:16038',
        },
        {
          name: '土地承包网签',
          image: require('@/assets/img/tdcbwq.png'),
          src: 'http://117.159.15.238:15063/#/login',
        },
        {
          name: '股权管理',
          image: require('@/assets/img/gqglxt.png'),
          src: 'http://117.159.15.238:15065',
        },
        {
          name: '土地改错',
          image: require('@/assets/img/tdgc.png'),
          src: 'http://117.159.15.238:15062/#/login',
        },
        {
          name: '清产核资',
          image: require('@/assets/img/qchz.png'),
          src: 'http://117.159.15.203:896/acvs/main/toLogin',
        },
      ],
      homeBackImg: require("@/assets/img/shangcai.png"),
      footList: [
        {
          title: "主管部门",
          company: "上蔡县农业农村局",
        },
        {
          title: "监督部门",
          company: "上蔡县纪委监委",
        },
        {
          title: "技术单位",
          company: "河南晟宇信息技术有限公司",
        },
      ],
      tabList: [
        { name: '首页', router: '/' },
        // { name: '所在区域', router: '/szqy', type: 1 },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '规章制度', router: '/policy' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 商丘
  "宁陵": {
    prod: {
      cityName: "宁陵县",
      deptId: 9307,
      lesseeId: 1666,
      // onlineUrl: "http://117.159.15.238:16071",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://117.159.53.44:10007/login?redirect=/index&ssoUrl=http://117.159.15.238:16046',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://117.159.53.44:10010/login?redirect=/index&ssoUrl=http://117.159.15.238:16046',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.53.44:10015?ssoUrl=http://117.159.15.238:16046',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.53.44:10014/login?redirect=/index&ssoUrl=http://117.159.15.238:16046',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://117.159.53.44:10009/login?redirect=/index&ssoUrl=http://117.159.15.238:16046',
        },
      ],
      homeBackImg: require("@/assets/img/ningling.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1, },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2, },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 商丘
  "永城": {
    prod: {
      cityName: "永城市",
      deptId: 9682,
      lesseeId: 9682,
      // onlineUrl: "http://117.159.15.238:16071",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://117.159.53.44:10007/login?redirect=/index&ssoUrl=http://117.159.15.238:16046',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16082',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://117.159.53.44:10010/login?redirect=/index&ssoUrl=http://117.159.15.238:16046',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.53.44:10015?ssoUrl=http://117.159.15.238:16046',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.53.44:10014/login?redirect=/index&ssoUrl=http://117.159.15.238:16046',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://117.159.53.44:10009/login?redirect=/index&ssoUrl=http://117.159.15.238:16046',
        },
      ],
      homeBackImg: require("@/assets/img/yongcheng.png"),
      tabList: [
        { name: '首页', router: '/' },
        // { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2, },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 濮阳
  "濮阳": {
    prod: {
      cityName: "濮阳市",
      homeTitle: "农村产权交易平台",
      toCityChangeTitle: true,
      deptId: 1625,
      lesseeId: 1625,
      deptCode: 4109,
      havaLink: false,
      notHaveJRFW: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.192.106.56:10009/login?redirect=/index&ssoUrl=http://117.159.15.238:16003',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.15.238:16020?ssoUrl=http://117.159.15.238:16003',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.15.238:16021?redirect=/index&ssoUrl=http://117.159.15.238:16003',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16005',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://117.159.15.238:10102/?redirect=/index&ssoUrl=http://117.159.15.238:16003',
        },
      ],
      homeBackImg: require("@/assets/img/hualongqu.png"),
      backGroundUrl: "http://117.159.15.238:16020?ssoUrl=http://117.159.15.238:16003",
      footList: [
        {
          title: "主管部门",
          company: "濮阳市农业农村局",
        },
        {
          title: "监管部门",
          company: "濮阳市纪委监委",
        },
        {
          title: "管理单位",
          company: '濮阳市农村集体"三资"服务办公室',
        },
        {
          title: "技术单位",
          company: "河南晟宇信息技术有限公司",
        },
      ],
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        // { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
    dev: {
      cityName: "濮阳市华龙区",
      homeTitle: "农村产权交易平台",
      toCityChangeTitle: true,
      deptId: 5287,
      lesseeId: 1625,
      deptCode: 410902,
      // onlineUrl: "http://39.164.142.214:10043",
      havaLink: true,
      freeBidding: true,
      startWebSocket: true,
      affirmMoney: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://39.164.142.214:10030/login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://39.164.142.214:10022?ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://39.164.142.214:2244?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://39.164.142.214:2250',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://39.164.142.214:10034?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
      ],
      homeBackImg: require("@/assets/img/hualongqu.png"),
      backGroundUrl: "http://39.164.142.214:10022?ssoUrl=http://39.164.142.214:10020",
      footList: [
        {
          title: "主管部门",
          company: "濮阳市农业农村局",
        },
        {
          title: "监管部门",
          company: "濮阳市纪委监委",
        },
        {
          title: "管理单位",
          company: '濮阳市农村集体"三资"服务办公室',
        },
        {
          title: "技术单位",
          company: "河南晟宇信息技术有限公司",
        },
      ],
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 濮阳
  "华龙区": {
    prod: {
      cityName: "濮阳市华龙区",
      homeTitle: "农村产权交易平台",
      toCityChangeTitle: true,
      deptId: 5287,
      lesseeId: 1625,
      deptCode: 410902,
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.192.106.56:10009/login?redirect=/index&ssoUrl=http://117.159.15.238:16003',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.15.238:16020?ssoUrl=http://117.159.15.238:16003',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.15.238:16021?redirect=/index&ssoUrl=http://117.159.15.238:16003',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16005',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://117.159.15.238:10102/?redirect=/index&ssoUrl=http://117.159.15.238:16003',
        },
      ],
      homeBackImg: require("@/assets/img/hualongqu.png"),
      // backGroundUrl: "http://117.159.15.238:16020?ssoUrl=http://117.159.15.238:16003",
      footList: [
        {
          title: "主管部门",
          company: "濮阳市农业农村局",
        },
        {
          title: "监管部门",
          company: "濮阳市纪委监委",
        },
        {
          title: "管理单位",
          company: '濮阳市农村集体"三资"服务办公室',
        },
        {
          title: "技术单位",
          company: "河南晟宇信息技术有限公司",
        },
      ],
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
    dev: {
      cityName: "濮阳市华龙区",
      homeTitle: "农村产权交易平台",
      toCityChangeTitle: true,
      deptId: 5287,
      lesseeId: 1625,
      deptCode: 410902,
      // onlineUrl: "http://39.164.142.214:10043",
      havaLink: true,
      freeBidding: true,
      startWebSocket: true,
      affirmMoney: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://39.164.142.214:10030/login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://39.164.142.214:10022?ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://39.164.142.214:2244?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://39.164.142.214:2250',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://39.164.142.214:10034?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
      ],
      homeBackImg: require("@/assets/img/hualongqu.png"),
      backGroundUrl: "http://39.164.142.214:10022?ssoUrl=http://39.164.142.214:10020",
      footList: [
        {
          title: "主管部门",
          company: "濮阳市农业农村局",
        },
        {
          title: "监管部门",
          company: "濮阳市纪委监委",
        },
        {
          title: "管理单位",
          company: '濮阳市农村集体"三资"服务办公室',
        },
        {
          title: "技术单位",
          company: "河南晟宇信息技术有限公司",
        },
      ],
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 濮阳
  "范县": {
    prod: {
      cityName: "范县",
      homeTitle: "农村集体“三资”监督管理平台",
      toCityChangeTitle: true,
      deptId: 5290,
      lesseeId: 1625,
      deptCode: 410926,
      havaLink: false,
      backstageUrlList: [],
      homeBackImg: require("@/assets/img/hualongqu.png"),
      showAppImage: true,
      appImage: require("@/assets/img/fanxianAppImage.png"),
      backGroundUrl: "http://117.159.15.238:16020?ssoUrl=http://117.159.15.238:16171",
      footList: [
        {
          title: "主管部门",
          company: "范县农业农村局",
        },
        {
          title: "监管部门",
          company: "范县纪委监委",
        },
        {
          title: "技术单位",
          company: "河南晟宇信息技术有限公司",
        },
      ],
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 濮阳
  "濮阳市一体化示范区": {
    prod: {
      cityName: "濮阳市一体化示范区",
      homeTitle: "农村集体资产监督管理平台",
      toCityChangeTitle: true,
      deptId: 58110,
      lesseeId: 1625,
      deptCode: 410901,
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.192.106.56:10009/login?redirect=/index&ssoUrl=http://117.159.15.238:16010',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.15.238:16020?ssoUrl=http://117.159.15.238:16010',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.15.238:16021?redirect=/index&ssoUrl=http://117.159.15.238:16010',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://117.159.15.238:16023?redirect=/index&ssoUrl=http://117.159.15.238:16010',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16159',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16158',
        },
      ],
      homeBackImg: require("@/assets/img/huojia.png"),
      backGroundUrl: "http://117.159.15.238:16020?ssoUrl=http://117.159.15.238:16010",
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        // { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
    dev: {
      cityName: "濮阳市一体化示范区",
      homeTitle: "农村产权交易平台",
      toCityChangeTitle: true,
      deptId: 58110,
      lesseeId: 1625,
      deptCode: 410901,
      // onlineUrl: "http://39.164.142.214:10043",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://39.164.142.214:10030/login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://39.164.142.214:10022?ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://39.164.142.214:2244?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://39.164.142.214:2250',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://39.164.142.214:10034?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
      ],
      homeBackImg: require("@/assets/img/hualongqu.png"),
      backGroundUrl: "http://39.164.142.214:10022?ssoUrl=http://39.164.142.214:10020",
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 濮阳
  "演示濮阳": {
    prod: {
      cityName: "演示濮阳",
      deptId: 9682,
      lesseeId: 9682,
      // onlineUrl: "http://117.159.15.238:16071",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://117.159.53.44:10007/login?redirect=/index&ssoUrl=http://117.159.15.238:16046',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16082',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://117.159.53.44:10010/login?redirect=/index&ssoUrl=http://117.159.15.238:16046',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.53.44:10015?ssoUrl=http://117.159.15.238:16046',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.53.44:10014/login?redirect=/index&ssoUrl=http://117.159.15.238:16046',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://117.159.53.44:10009/login?redirect=/index&ssoUrl=http://117.159.15.238:16046',
        },
      ],
      homeBackImg: require("@/assets/img/yongcheng.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1, },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2, },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 濮阳
  "清丰县": {
    prod: {
      cityName: "濮阳市清丰县",
      homeTitle: "农村产权交易平台",
      toCityChangeTitle: true,
      deptId: 5288,
      lesseeId: 1625,
      deptCode: 410922,
      // onlineUrl: "http://117.159.15.238:16029",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.192.106.56:10009/login?redirect=/index&ssoUrl=http://1.192.106.56:10008',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.15.238:16020?ssoUrl=http://1.192.106.56:10008',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.15.238:16021?redirect=/index&ssoUrl=http://1.192.106.56:10008',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16132',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://117.159.15.238:16023?redirect=/index&ssoUrl=http://1.192.106.56:10008',
        },
      ],
      homeBackImg: require("@/assets/img/qingfengxian.png"),
      showAppImage: true,
      appImage: require("@/assets/img/qingfengAppImage.png"),
      backGroundUrl: "http://117.159.15.238:16020?ssoUrl=http://1.192.106.56:10008",
      footList: [
        {
          title: "主管部门",
          company: "濮阳市农业农村局",
        },
        {
          title: "监管部门",
          company: "濮阳市纪委监委",
        },
        {
          title: "管理单位",
          company: '濮阳市农村集体"三资"服务办公室',
        },
        {
          title: "技术单位",
          company: "河南晟宇信息技术有限公司",
        },
      ],
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
    dev: {
      cityName: "濮阳市清丰县",
      homeTitle: "农村产权交易平台",
      toCityChangeTitle: true,
      deptId: 5287,
      lesseeId: 1625,
      deptCode: 410902,
      // onlineUrl: "http://39.164.142.214:10043",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://39.164.142.214:10030/login?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://39.164.142.214:10022?ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://39.164.142.214:2244?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://39.164.142.214:2250',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://39.164.142.214:10034?redirect=/index&ssoUrl=http://39.164.142.214:10020',
        },
      ],
      homeBackImg: require("@/assets/img/hualongqu.png"),
      backGroundUrl: "http://39.164.142.214:10022?ssoUrl=http://39.164.142.214:10020",
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 信阳
  "信阳": {
    prod: {
      cityName: "信阳市",
      // homeTitle: "农村产权交易中心",
      homeTitle: "农村(社区)集体“三资”监督管理平台",
      doubletitle: false,
      doubletitleText: "农村产权交易信息服务平台",
      toCityChangeTitle: true,
      deptId: 1676,
      deptCode: 4115,
      lesseeId: 1676,
      // onlineUrl: "http://117.159.15.238:16087",
      havaLink: true,
      startWebSocket: true,
      freeBidding: true,
      goJRFWInfo: true,
      ZCZSName: "国有资产",
      // 头部路由不跳转的地市
      notGoCityList: [
        "浉河区",
        "平桥区",
        "上天梯非金属矿管理区",
        "羊山新区",
        "金牛山管理区",
        "高新区",
        "工业城示范区",
      ],
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://1.192.106.51:10012?redirect=/index&ssoUrl=http://117.159.15.238:16086',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16093/',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://61.158.162.179:10005?redirect=/index&ssoUrl=http://117.159.15.238:16086',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16094',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.15.238:16153?ssoUrl=http://117.159.15.238:16086',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.15.238:16157?redirect=/index&ssoUrl=http://117.159.15.238:16086',
        },
        {
          name: '乡土人才',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://39.164.142.214:9916/xyxl',
        },
      ],
      homeBackImg: require("@/assets/img/xinyang.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '国有资产', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
    dev: {
      cityName: "信阳市",
      homeTitle: "农村产权交易中心",
      toCityChangeTitle: true,
      deptId: 1676,
      deptCode: 411000,
      lesseeId: 1676,
      // onlineUrl: "http://117.159.15.238:16071",
      havaLink: true,
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://117.159.15.238:16154?redirect=/index&ssoUrl=http://117.159.15.238:16086',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16093/',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://117.159.15.238:16156?redirect=/index&ssoUrl=http://117.159.15.238:16086',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16094',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.15.238:16153?ssoUrl=http://117.159.15.238:16086',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.15.238:16157?redirect=/index&ssoUrl=http://117.159.15.238:16086',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://117.159.15.238:16155?redirect=/index&ssoUrl=http://117.159.15.238:16086',
        },
      ],
      homeBackImg: require("@/assets/img/xinyang.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '国有资产', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 演示环境
  "演示环境": {
    prod: {
      cityName: "",
      // homeTitle: "农村集体综合服务平台",
      deptId: 1632,
      deptCode: 4110,
      toCityChangeTitle: false,
      lesseeId: 1632,
      showAuctionRecords: false,
      // onlineUrl: "http://117.159.15.238:16042",
      havaLink: true,
      notGoCityList: [
        "开发区",
        "东城区",
        "示范区",
      ],
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://114.116.254.116:10089?redirect=/index&ssoUrl=http://114.116.254.116:10096',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://114.116.254.116:10087?ssoUrl=http://114.116.254.116:10096',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://114.116.254.116:10086?redirect=/index&ssoUrl=http://114.116.254.116:10096',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://114.116.254.116:10084?redirect=/index&ssoUrl=http://114.116.254.116:10096',
        },
        // {
        //   name: '新型经营主体',
        //   image: require('@/assets/img/xxjyzt.png'),
        //   src: 'http://1.92.70.79:10014?redirect=/index&ssoUrl=http://114.116.254.116:10096',
        // },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://114.116.254.116:10085',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://114.116.254.116:10083',
        },
      ],
      homeBackImg: require("@/assets/img/xuchang.png"),
      tabList: [
        { name: '首页', router: '/' },
        { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
  // 三门峡
  "卢氏": {
    prod: {
      cityName: "卢氏县",
      homeTitle: "“三资”智慧化监管平台",
      toCityChangeTitle: true,
      deptId: 1649,
      deptCode: 411224,
      lesseeId: 1649,
      havaLink: false,
      // http://117.159.15.238:16161/ 
      backGroundUrl: "http://117.159.15.238:16153?ssoUrl=http://117.159.15.238:16151",
      backstageUrlList: [
        {
          name: '财务管理',
          image: require('@/assets/img/cwgl.png'),
          src: 'http://117.159.15.238:16154?redirect=/index&ssoUrl=http://117.159.15.238:16151',
        },
        {
          name: '产权交易',
          image: require('@/assets/img/jygl.png'),
          src: 'http://117.159.15.238:16153?ssoUrl=http://117.159.15.238:16151',
        },
        {
          name: '网报支付',
          image: require('@/assets/img/wbzf.png'),
          src: 'http://117.159.15.238:16156?redirect=/index&ssoUrl=http://117.159.15.238:16151',
        },
        {
          name: '合同管理',
          image: require('@/assets/img/htgl.png'),
          src: 'http://117.159.15.238:16157?redirect=/index&ssoUrl=http://117.159.15.238:16151',
        },
        {
          name: '新型经营主体',
          image: require('@/assets/img/xxjyzt.png'),
          src: 'http://117.159.15.238:16155?redirect=/index&ssoUrl=http://117.159.15.238:16151',
        },
        {
          name: '预警监测',
          image: require('@/assets/img/jcyj.png'),
          src: 'http://117.159.15.238:16150',
        },
        {
          name: '财务公开',
          image: require('@/assets/img/nydsjzx.png'),
          src: 'http://117.159.15.238:16139',
        },
        {
          name: '土地改错',
          image: require('@/assets/img/qchz.png'),
        },
      ],
      homeBackImg: require("@/assets/img/lushi.png"),
      showAppImage: true,
      appImage: require("@/assets/img/lushiAppImage.png"),
      footList: [
        {
          title: "主管部门",
          company: "卢氏县农业农村局",
        },
        {
          title: "监督部门",
          company: "卢氏县纪委监委",
        },
        {
          title: "技术单位",
          company: "河南晟宇信息技术有限公司",
        },
      ],
      tabList: [
        { name: '首页', router: '/' },
        // { name: '所在区域', router: '/szqy', type: 1 },
        { name: '新闻动态', router: '/pressCenter' },
        { name: '交易类型', router: '/jylx', type: 2 },
        { name: '交易项目', router: '/tradingProject' },
        { name: '资产招商', router: '/propertyAttract' },
        { name: '交易指南', router: '/tradingGuide' },
        { name: '交易大数据', router: '/xinyangBigData', andCity: true },
        { name: '政策法规', router: '/policiesRegulations' },
        { name: '资料下载', router: '/dataDownload' },
        { name: '关于我们', router: '/aboutUs' },
      ],
    },
  },
}
/*
cityName 城市名称
deptId 区域id
lesseeId 租户id
havaLink 是否展示后台链接
backstageUrlList 后台链接列表
homeBackImg 首页背景图
tabList 导航栏列表
showAppImage 是否展示app图标
appImage app图标
footList 底部信息列表
doubletitle 是否展示二层标题
doubletitleText 二层标题内容(不与cityName拼接)
homeTitle 需与cityName拼接的标题
deptCode 区域编码(交易大数据)
startWebSocket 是否开启websocket(需在mainReqUrl.js中配置socketUrl)
chargeStandard 是否启用收费标准
haveFootLink 是否含有底部链接
footLinkList 底部链接列表
loginImg 登录背景图
toCityChangeTitle 跳转城市是否切换标题地区部分
showAuctionRecords 是否显示拍卖记录
notShowAuctionRecordsName 是否不显示竞拍记录中人的姓名(姓名替换为xxx)
freeBidding 是否启用自由竞价
notGoCityList 交易大数据不跳转的地市
backGroundUrl 背景图片
haveCJGG 首页新闻是否展示成交公告
affirmMoney 是否在出价前展示弹窗确认金额
notShowWatchNum 不展示报名人数
customZTBName 自定义招投标类型名称 默认值:招投标
initPriceTitle 转出项目详情页初始价格名称 默认值 公告价格
bargainPriceTitle 转出项目详情页初始价格名称 默认值 中标价格
notHaveJRFW 是否展示金融服务 默认值 false(展示)
goJRFWInfo 是否可以跳转金融服务详情页面
projectTypeList 项目类型列表 默认值 供应项目 需求项目 招投标项目
projectStatusList 项目分类状态类型 默认值 公示中 报名中 竞价中 已成交
ZCZSName 资产招商名字自定义 默认值 资产招商
homeShowLogin 首页是否展示登录框 默认值 false
projectAllStatus 项目所有状态自定义 默认值 2,3,4,5,6,7,8,9,10,11
projectCardShowStatusList 项目卡片展示状态自定义 默认值 ['','','公示中','公示结束','报名中','报名结束','竞价中','已成交','已成交','已成交',"已结束","已结束"]
notShowPublicity 是否不展示公示期 默认值 false

请求地址配置文件 mainReqUrl.js
*/
module.exports = {
  cityDetail: prefecturalList["平原新区"]["prod"]
}